export class ValidatedTextInput extends HTMLElement {
  constructor () {
    super()
    this.input = this
    this.textInputElement = this.input.querySelector('input[type="text"]')

    this.notificationElement = this.querySelector('[data-input-validation-notification]')
    this.notificationText = this.notificationElement ? this.notificationElement.querySelector('[data-notification-text]') : null

    this.hideNotification()

    this.textInputElement.addEventListener('keyup', (e) => {
      this.validateInput(e)
    })
  }

  validateInput () {
    // Extend this with your own function, see input-birthday.js
  }

  hideNotification () {
    this.textInputElement.setCustomValidity('')
    if (this.notificationElement) {
      this.notificationElement.classList.add('!hidden')
      this.notificationText.innerHTML = ''
    }
  }

  showNotification (message) {
    this.textInputElement.setCustomValidity(message)
    if (this.notificationElement) {
      this.notificationElement.classList.remove('!hidden')
      this.notificationText.innerHTML = message
    }
  }
}

if (!customElements.get('validated-input')) {
  customElements.define('validated-input', ValidatedTextInput)
}
